import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltyCheckApi, NoveltyCheckApiImpl } from './apis';
import {
    NoveltyExampleService,
    NoveltyExampleServiceImpl,
} from './services/novelty-example-service';

export const noveltyCheckContainer = new ContainerModule((bind) => {
    bind(NoveltyCheckApi).to(NoveltyCheckApiImpl);
    bind(NoveltyExampleService).to(NoveltyExampleServiceImpl);
});
export { default as NoveltySearchContainer } from './components/containers/NoveltySearchContainer.vue';
